export const flyer = {
	name: 'Untitled Flyer Template',
	variant: 'design',
	json: {
		width: 2550,
		height: 3300,
		fonts: [],
		pages: [
			{
				id: 'page_1',
				children: [],
				width: 'auto',
				height: 'auto',
				background: 'white',
				bleed: 0,
			},
		],
		unit: 'px',
		dpi: 300,
	},
	status: 'draft',
	history: [],
	tags$Category: [],
	tags$General: [
		'0:Medium:Print',
		'0:Distribution:Mail',
		'0:Format:Flyer',
		'0:Layout:Portrait',
		'0:Dimensions:8.5x11',
	],
	etc: {
		directives: {},
		cfg: {
			global: {
				minPages: 1,
				maxPages: 50,
			},
			customer: {
				minPages: 1,
				maxPages: 50,
			},
			order: {
				countries: null,
				itemId: 'flyer',
			},
			canBeResized: true,
		},
	},
};

export default flyer;
